import {useContext, useEffect, useMemo, useState} from "react";
import MainInfo from "./MainInfo";
import Instructions from "./Instructions";
import EntryCollection from "./EntryCollection/EntryCollection";
import Delivery from "./Delivery";
import {progressContext, ProgressProvider} from "../../../context/progress";
import Value from "./Value";

export default function Job({job}) {
	const [disabled, setDisabled] = useState([false, true, true]);
	const {progress: {qaErrors, done, mainQaErrors}} = useContext(progressContext);

	console.log('qa-erros', qaErrors)
	function enable(tabN) {
		setDisabled(prev => {
			const newS = [...prev];
			newS[tabN - 1] = false;
			return newS;
		});
	}
	function disable(tabN) {
		setDisabled(prev => {
			const newS = [...prev];
			newS[tabN - 1] = true;
			return newS;
		});
	}
	function goto(tabId) {
		const tab = new window.bootstrap.Tab(document.getElementById("tab" + tabId));
		tab.show();
	}

	const hasEntryInputs = useMemo(() => {
		return [...job.entryInputs.booleans, ...job.entryInputs.textFields, ...job.entryInputs.dropDowns, ...job.entryInputs.dropDownsMultiple, ...job.entryInputs.files, ...job.entryInputs.regexFields, ...job.entryInputs.lists].length > 0;
	}, [job.entryInputs]);
	const hasGeneralInputs = useMemo(() => {
		return [...job.generalInputs.booleans, ...job.generalInputs.textFields, ...job.generalInputs.dropDowns, ...job.generalInputs.dropDownsMultiple, ...job.generalInputs.files, ...job.generalInputs.regexFields, ...job.generalInputs.lists].length > 0;
	}, [job.generalInputs]);

	useEffect(() => {
		if (!hasGeneralInputs) {
			enable(2);
			goto(2);
		}
	}, [hasGeneralInputs]);

	// The card is held to the viewport so the Delivery tab can scroll its own table. An entry with
	// dozens of inputs is far taller than that, so the card scrolls rather than spilling out of its
	// white background.
	return (
			<div className={"shadow-sm border p-2 p-md-3 bg-white mx-0 mx-md-2 flex-fill d-flex flex-column mb-2 h-100 overflow-auto"}>
				<h2 className={"text-break"}>{job.name}</h2>

				<Instructions job={job} />
				
				{/* Don't show earned so far */}
				{/* <Value job={job} /> */}

				<ul className="nav nav-tabs flex-column flex-md-row" id="myTab" role="tablist">
					{hasGeneralInputs && <li className="nav-item" role="presentation">
						<button disabled={disabled[0]} className="nav-link active text-start" id="tab1" data-bs-toggle="tab"
								data-bs-target="#tab1-pane" type="button" role="tab" aria-controls="tab1-pane"
								aria-selected="true" style={mainQaErrors?.length > 0 ? {color: "red"} : {}}>1. Main Info
						</button>
					</li>}
					{hasEntryInputs && <li className="nav-item" role="presentation">
						<button disabled={disabled[1]} className="nav-link text-start" id="tab2" data-bs-toggle="tab"
								data-bs-target="#tab2-pane" type="button" role="tab"
								aria-controls="tab2-pane" aria-selected="false">{hasGeneralInputs ? '2': '1'}. Entry collection
						</button>
					</li>}
					<li className="nav-item" role="presentation">
						<button disabled={disabled[2]} className="nav-link text-start" id="tab3" data-bs-toggle="tab"
								data-bs-target="#tab3-pane" type="button" role="tab"
								aria-controls="tab3-pane" aria-selected="false" style={qaErrors > 0 ? {color: "red"}: {}}>{hasEntryInputs ? (hasGeneralInputs ? '3': '2'): '2'}. Delivery ({qaErrors} QA issues / {done} total)
						</button>
					</li>
				</ul>
				<div className="tab-content pt-3 flex-fill d-flex flex-column h-100" id="myTabContent">
						{hasGeneralInputs && <div className="tab-pane fade show active" id="tab1-pane" role="tabpanel" aria-labelledby="tab1"
							 tabIndex="0">
							<MainInfo enable={enable} disable={disable} goto={goto} job={job} hasEntryInputs={hasEntryInputs}/>
						</div>}
						{hasEntryInputs && <div className="tab-pane fade" id="tab2-pane" role="tabpanel" aria-labelledby="tab2"
							 tabIndex="0">
							<EntryCollection hasGeneralInputs={hasGeneralInputs} enabled={!disabled[1]} enable={enable} disable={disable} goto={goto} job={job} />
						</div>}
						<div className="tab-pane fade" id="tab3-pane" role="tabpanel" aria-labelledby="tab3"
							 tabIndex="0">
							<Delivery enabled={!disabled[2]} goto={goto} disable={disable} job={job} hasEntryInputs={hasEntryInputs}/>
						</div>
				</div>
			</div>
	);
}
